import { Temporal } from 'temporal-polyfill';

import {
  ClassTimeType,
  CoachViewableStudentGroupWithScheduleAndLevel,
  SortedDaysOfWeek,
} from '@airreading/common/data';

/**
 * Current regular (non one-time) groups that still have sessions left, sorted by their first meeting
 * block's day of week and start time. One-time groups are listed in their own section.
 */
export function getCurrentRegularStudentGroups(
  classes: CoachViewableStudentGroupWithScheduleAndLevel[],
): CoachViewableStudentGroupWithScheduleAndLevel[] {
  return classes
    .filter((c) => (c.futureSessions ?? 0) > 0 && c.classTime.type !== ClassTimeType.one_time)
    .toSorted((a, b) => {
      const aFirstBlock = a.classTime.meetingBlocks?.[0];
      const bFirstBlock = b.classTime.meetingBlocks?.[0];

      if (!aFirstBlock || !bFirstBlock) return 0;

      const dayDiff = SortedDaysOfWeek.indexOf(aFirstBlock.day) - SortedDaysOfWeek.indexOf(bFirstBlock.day);
      if (dayDiff !== 0) return dayDiff;

      return Temporal.PlainTime.compare(aFirstBlock.startPlainTime, bFirstBlock.startPlainTime);
    });
}
